<template>
  <div :tooltip="tooltip" class="input-field"
      :class="{'input-field--readonly': this.readonly,
               'input-field--disabled': this.disabled,
               'input-field--vertical': this.vertical,
               'input-field--on-title': this.onTitle,
               'input-field--stretch': this.stretch,
               'input-field--spacing-off': this.spacingOff,
               'input-field--text-group': this.textGroup}">
      <input v-if="inputOut"
        v-bind="$attrs"
        :id="id"
        :value="value"
        v-model="modelValue"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        v-on="inputListeners"/>
      <cleave v-else-if="vMoney" 
        :options="format" 
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        :id="id"
        :value="value"
        v-on="inputListeners"></cleave>
      <input v-else
          v-bind="$attrs"
          :id="id"
          :value="value"
          :placeholder="placeholder"
          :readonly="readonly"
          :disabled="disabled"
          v-on="inputListeners"
          :style="`min-width: ${this.minWidth};`"/>
      <label :for="id" class="input-field__label">
        <slot></slot>
      </label>
      <slot name="helper"></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      required: false
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    minWidth: {
      type: String,
      required: false
    },
    stretch: {
      type: Boolean,
      required: false
    },
    spacingOff: {
      type: Boolean,
      required: false
    },
    textGroup: {
      type: Boolean,
      required: false
    },
    vertical: {
      type: Boolean,
      required: false
    },
    onTitle: {
      type: Boolean,
      required: false
    },
    resizable: {
      type: Boolean,
      required: false
    },
    fontSizeFactor: {
      required: false
    },
    inputOut: {
      type: Boolean,
      required: false
    },
    vMoney : {
      type : Boolean,
      default : false
    },
    format : Object,
    tooltip : {
      type : String,
      required : false, 
      default : null
    }
  },
  data() {
    return {
      labelActive: false,
      modelValue: this.value
    }
  },
  mounted() {
    if (this.inputOut && !this.value) {
      this.modelValue = this.value
    }
    if(this.resizable) {
      function resizable (el, factor) {
        var int = Number(factor) || 7.7;
        function resize() {el.style.width = ((el.value.length+1) * int) + 'px'}
        var e = 'keyup,keypress,focus,blur,change'.split(',');
        for (var i in e) el.addEventListener(e[i],resize,false);
        resize();
      }
      resizable(document.getElementById(this.id),this.fontSizeFactor);
    }
  },
  computed: {
    inputListeners: function () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            if (event.target !== null && event.target !== undefined)
            {
              let value = event.target.value
              vm.$emit('input', value)
            }
            else 
            {
              let value = event;
              vm.$emit('input', value)
            }
          },
          focus: function (event) {
            // 
          },
          blur: function (event) {
            // 
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/InputField.vue